/** Estado de una medida correctiva (requirement). No es el estado del análisis. */
export type CorrectiveActionStatus =
  | 'not_started'
  | 'assigned'
  | 'in_progress'
  | 'pending'
  | 'completed';

/** Estados que la tabla del dashboard considera por atender (todos menos completed). */
export const OPEN_CORRECTIVE_ACTION_STATUSES: readonly CorrectiveActionStatus[] = [
  'not_started',
  'assigned',
  'in_progress',
  'pending',
];
